const myTokens = (category) => category === 'all';

export const canReadToken = (category, { permissions }) => (
  myTokens(category) ? permissions.users.token_read : permissions.tokens.read
);

export const canCreateToken = (category, { permissions }) => (
  myTokens(category) ? permissions.users.token_create : permissions.tokens.create
);

export const canDeleteToken = (category, { permissions }) => (
  myTokens(category) ? permissions.users.token_destroy : permissions.tokens.destroy
);

export const canDisableToken = (category, { permissions }) => (
  myTokens(category) ? permissions.users.token_disable : permissions.tokens.disable
);

export default myTokens;
